const DEV = {
API_BASE:'https://accounts.uat.chqbook.com/api',
SITE_URL:'https://uat.chqbook.com'
};

const STAGING = {
  API_BASE: 'https://accounts.staging.chqbook.com/api',
  SITE_URL: 'https://staging.chqbook.com'
};

const UAT = {
  API_BASE: 'https://accounts.uat.chqbook.com/api',
  SITE_URL: 'https://uat.chqbook.com'
};

const PROD = {
  API_BASE:'https://accounts.chqbook.com/api',
  SITE_URL:'https://www.chqbook.com'
};

let config = {};

switch (process.env.REACT_APP_ENV) {
  case 'staging': {
    config = STAGING;
    break;
  }
  case 'uat': {
    config = UAT;
    break;
  }
  case 'production': {
    config = PROD;
    break;
  }
  default:
    config = DEV
    break;
}

export default {
  // Add common config values here
  ...config
};



// WEBPACK FOOTER //
// ./src/config.js